import { render, staticRenderFns } from "./PositionSettingsTable.vue?vue&type=template&id=a2428ac8&scoped=true&"
import script from "./PositionSettingsTable.vue?vue&type=script&lang=js&"
export * from "./PositionSettingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2428ac8",
  null
  
)

export default component.exports